import { render, staticRenderFns } from "./Peticiones.vue?vue&type=template&id=10febceb&lang=pug"
import script from "./Peticiones.vue?vue&type=script&lang=js"
export * from "./Peticiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports